module.exports = __webpack_public_path__ + "img/inst-modal-13.1f1fe369.png";